import script from "./WeeklySchedule.vue?vue&type=script&setup=true&lang=js"
export * from "./WeeklySchedule.vue?vue&type=script&setup=true&lang=js"

import "./WeeklySchedule.vue?vue&type=style&index=0&id=274d65d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-274d65d7"]])

export default __exports__